import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  updateProfile,
} from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { auth, db, googleProvider } from './firebase';

export async function isUsernameTaken(username) {
  const ref = doc(db, 'usernames', username.toLowerCase());
  const snap = await getDoc(ref);
  return snap.exists();
}

export async function checkUserExists(uid) {
  const snap = await getDoc(doc(db, 'users', uid));
  return snap.exists();
}

export async function finishGoogleSignup({ user, username }) {
  const uname = username.toLowerCase();
  await updateProfile(user, { displayName: username });
  await setDoc(doc(db, 'users', user.uid), {
    uid: user.uid,
    username: uname,
    displayName: username,
    email: user.email,
    photoURL: user.photoURL || '',
    createdAt: new Date().toISOString(),
  });
  await setDoc(doc(db, 'usernames', uname), { uid: user.uid });
}

export async function signUp({ username, birthday, email, password }) {
  const cred = await createUserWithEmailAndPassword(auth, email, password);
  const uid = cred.user.uid;

  await updateProfile(cred.user, { displayName: username });

  // save user document
  await setDoc(doc(db, 'users', uid), {
    uid,
    username: username.toLowerCase(),
    displayName: username,
    birthday,
    email,
    createdAt: new Date().toISOString(),
  });

  // reserve username
  await setDoc(doc(db, 'usernames', username.toLowerCase()), { uid });

  return cred.user;
}

export async function signIn({ email, password }) {
  const cred = await signInWithEmailAndPassword(auth, email, password);
  return cred.user;
}

export async function signInWithGoogle() {
  const cred = await signInWithPopup(auth, googleProvider);
  return cred.user;
}
